import React, { Component } from "react";
import { Table, Button, Modal, Row, Col, Tooltip, message, Icon, Select } from "antd";
import axios from "axios";
import "./Pages.css";
import PedidoForm from '../components/PedidoForm';
import PedidosPrintModal from "../relatorios/PedidosPrintModal";
import FiltrosForm from '../components/FiltrosForm';
import ModalPadraoForm from '../components/ModalPadraoForm';
import JustificativaForm from '../components/JustificativaForm';
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao, getTipoUsuario, getEmpresa } from "../utils/LoginManager";
import InputForm from "../components/InputForm";
import Colors from "../utils/Colors";


const dateFormat = 'DD/MM/YYYY'
const { Column } = Table;
const ButtonGroup = Button.Group;
const { Option } = Select;


export default class extends Component {
  state = {
    listaRegistros: [],
    registro: '',
    eventStatus: '',
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,

    qtdePedNSinc: 0,
    qtdePed: 0,
    qtdeOrc: 0,
    vlrTotalPed: 0,
    vlrTotalOrc: 0,

    formFiltroVisivel: false,
    modalListaVisible: false,
    formJustfVisivel: false,
    justificativa: '',

    filtros: {
      tipoTela: 'PED',
      buscaOrdem: { campo: 'ven_dt_venda', ordem: 'DESC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaMes: 0,
      buscaAno: 0,
      buscaPessoa: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaMunicipio: { key: '0', },
      buscaAgruparCidades: 0,
      buscaGrupoProduto: { key: '0' },
      buscaProduto: { key: '0' },
      buscaTipo: { key: 'X' },
      buscaControle: '',
      buscaAtividade: { key: '0', },
      buscaTipoAtiv: { key: 'X' },
      buscaStatusPedido: { key: '0' },
    }

  };

  componentDidMount() {
    this.buscaStatus();
    const usuario = getUsuario();
    getEmpresa().then(codEmpresa => {
      getTipoUsuario().then(tipoUsuario => {
        this.state.filtros.buscaUsuario = {
          key: getTemPermissao('UsuarioSupervisor', 'cons') ? '0' : usuario.usu_cpf
        }
        this.setState({
          usuario,
          codEmpresa,
          tipoUsuario,
        }, this.getListaRegistros);
      })
    })
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ carregando: true, qtdePed: 0, qtdeOrc: 0, qtdePedNSinc: 0, vlrTotalPed: 0, vlrTotalOrc: 0 });
    const { pagina, limite } = this.state;

    const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaMunicipio,
      buscaUsuario, buscaTipo, buscaStatusPedido, buscaOrdem } = this.state.filtros;

    let ven_dt_venda_ini = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      ven_dt_venda_ini = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let ven_dt_venda_fim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      ven_dt_venda_fim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/vendas', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          numero: buscaControle,
          codCliente: buscaPessoa.key,
          cidade: buscaMunicipio.key,
          usuario: buscaUsuario.key,
          tipoVenda: buscaTipo.key,
          status: buscaStatusPedido.key,
          ven_dt_venda_ini,
          ven_dt_venda_fim,
          print: 0,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data.consulta;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),

          vlrTotalPed: response.data.vlrTotalPed,
          qtdePed: response.data.qtdePed,
          vlrTotalOrc: response.data.vlrTotalOrc,
          qtdeOrc: response.data.qtdeOrc,
          qtdePedNSinc: response.data.qtdePedNSinc,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };





  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    // console.log('Registro gravar: ', registro);

    let request;
    if (registro.ven_idf) {
      request = axios.put(`/vendas/update/${registro.ven_idf}`, registro);
    } else {
      request = axios.post(`/vendas/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Pedido gravado com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  }

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      visualizar: false,
      registroSelecionado: {
        dados: {
          ven_idf: 0,
          ven_numero: '',
          ven_dt_venda: moment().format('DD/MM/YYYY'),
          ven_obs: '',
          ven_dados_cliente: '',
          ven_qtde_itens: 0,
          ven_vlr_itens: 0,
          ven_vlr_acres: 0,
          ven_vlr_frete: 0,
          ven_vlr_desc: 0,
          ven_vlr_total: 0,
          ven_pessoa: { key: '0' },
          // ven_usuario: { key: '0' },
          ven_cond_pagto: { key: '0' },
          ven_tipo_venda: { key: this.state.usuario.ue_tipo_pedido_padrao ? this.state.usuario.ue_tipo_pedido_padrao : 'P' },
          ven_tipo_frete: { key: 'CIF' },
          ven_filial: this.state.usuario.emp_filial1 ? '0' : this.state.usuario.emp_filial,

          ven_usuario: {
            key: getTemPermissao('UsuarioSupervisor', 'cons') ? '0' : this.state.usuario.usu_cpf
          },

          listaProdutos: [],
          visualizando: false,
        }
      },
      registroParcela: {
        vp_parcela: 0,
        vp_data_parcela: '',
        vp_valor_parcela: 0,
      }

    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  onEditarClick = registro => {
    this.setState({ carregando: true });
    axios.get(`/vendas/show/${registro.ven_idf}`)
      .then(response => {
        const { data } = response;

        // console.log('-------------------------------onEditarClick: ', data.dados)

        data.dados.ven_tipo_venda = {
          key: String(data.dados.ven_tipo_venda),
          label: '',
        }
        data.dados.ven_tipo_frete = {
          key: String(data.dados.ven_tipo_frete),
          label: '',
        }
        data.dados.ven_filial = {
          key: String(data.dados.ven_filial),
          label: '',
        }
        data.dados.ven_pessoa = {
          key: String(data.dados.ven_pessoa),
          label: data.dados.pes_nome,
        }
        data.dados.ven_usuario = {
          key: String(data.dados.ven_usuario),
          label: data.dados.usu_nome,
        }
        data.dados.ven_cond_pagto = {
          key: data.dados.ven_cond_pagto ? String(data.dados.ven_cond_pagto) : '0',
          label: data.dados.cp_descricao ? data.dados.cp_descricao : '',
          qtdeParc: data.dados.cp_qtde_parc ? data.dados.cp_qtde_parc : 0,
          parcelas: data.dados.cp_parcelas ? data.dados.cp_parcelas : '0'
        }

        data.dados.ven_dt_venda = moment(data.dados.ven_dt_venda, 'YYYY-MM-DD').format('DD/MM/YYYY');

        data.dados.visualizando = data.dados.ven_dt_enviado ? true : getTemPermissao('PedidosPage', 'editar') ? false : true;

        // console.log('onEditarClick: ', data)

        this.setState({
          formVisivel: true,
          registroSelecionado: data,
          carregando: false,
          // editando: true,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };

  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir a venda Nº ${registro.ven_numero} do cliente ${registro.pes_nome} ?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/vendas/delete/${registro.ven_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.ven_idf === registro.ven_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
          })
      }
    })
  };


  onNovaVendaProducaoClick = (listaProdutos) => {
    this.setState({
      formVisivel: true,
      modalListaVisible: false,
      visualizar: false,
      registroSelecionado: {
        dados: {
          ven_idf: 0,
          ven_numero: '',
          ven_dt_venda: moment().format('DD/MM/YYYY'),
          ven_obs: '',
          ven_dados_cliente: '',
          ven_qtde_itens: 0,
          ven_vlr_itens: 0,
          ven_vlr_acres: 0,
          ven_vlr_frete: 0,
          ven_vlr_desc: 0,
          ven_vlr_total: 0,
          ven_pessoa: { key: '0' },
          // ven_usuario: { key: '0' },
          ven_cond_pagto: { key: '0' },
          ven_tipo_venda: { key: this.state.usuario.ue_tipo_pedido_padrao ? this.state.usuario.ue_tipo_pedido_padrao : 'P' },
          ven_tipo_frete: { key: 'CIF' },
          ven_filial: this.state.usuario.emp_filial1 ? '0' : this.state.usuario.emp_filial,

          ven_usuario: {
            key: getTemPermissao('UsuarioSupervisor', 'cons') ? '0' : this.state.usuario.usu_cpf
          },

          visualizando: false,
        },
        listaProdutos,
      },
      registroParcela: {
        vp_parcela: 0,
        vp_data_parcela: '',
        vp_valor_parcela: 0,
      }

    })
  }

  onNovoOrdemProducao = () => {
    this.setState({
      modalListaVisible: true,
      telaModal: 'EstoqueProducao',
    })
  };

  onFecharModalLista = () => {
    this.setState({
      modalListaVisible: false,
      telaModal: '',
    });
  }


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    this.setState({
      [id]: value
    });
  };

  onChangeVendedor = event => {
    this.setState({
      buscaUsuario: event.buscaUsuario,
    });
  }

  onBuscar = event => {
    event.preventDefault();
    this.getListaRegistros();
  }


  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span style={{ fontSize: 11 }}>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      <span></span>
    }
  }


  renderDataRecebido = (data, registro) => {
    // console.log('renderDataRecebido: ', registro)

    if ((registro.sv_descricao === 'REVISAR') || (registro.sv_descricao === 'BLOQUEADA')) {
      if (registro.vj_data) {
        return (
          <span style={{ fontSize: 11 }}>
            {registro.sv_descricao === 'REVISAR' ? (
              <span>
                {moment(registro.vj_data) <= moment(registro.ven_dt_venda) ? (
                  <Tooltip title="REVISADO">
                    <Icon type="check-circle" style={{ marginRight: 5, color: "#10734a" }} />
                  </Tooltip>
                ) : (
                  <Tooltip title="AGUARDANDO REVISÃO">
                    <Icon type="exclamation-circle" style={{ marginRight: 5, color: "#fdd835" }} />
                  </Tooltip>
                )}
              </span>
            ) : null}
            <Tooltip title={registro.vj_justf_bloq}>
              <span style={{ fontSize: 11, color: "#b71c1c" }}>
                {moment(registro.vj_data).format('DD/MM/YYYY HH:mm')}
              </span>
            </Tooltip>
          </span>
        )
      } else {
        if ((registro.sv_descricao === 'BLOQUEADA') && (registro.ven_dt_recebido)) {
          return (
            <Tooltip title="BLOQUEADA">
              <span style={{ fontSize: 11, color: "#b71c1c" }}>
                {moment(registro.ven_dt_recebido).format('DD/MM/YYYY HH:mm')}
              </span>
            </Tooltip>
          )
        } else {
          <span></span>
        }
      }
    } else {
      if (registro.ven_dt_recebido) {
        return (
          <span style={{ fontSize: 11 }}>
            {moment(registro.ven_dt_recebido).format('DD/MM/YYYY HH:mm')}
          </span>
        )
      } else {
        <span></span>
      }
    }
  }

  renderDataEnviado = (data, registro) => {
    if (data) {
      const dataMoment = moment(data);
      if ((this.state.usuario) && ((!this.state.usuario.usu_tipo) || (getTemPermissao('UsuarioSupervisor', 'cons')))) {
        return (
          <span style={{ fontSize: 11 }}>
            <Tooltip title="Excluir data de Sincronização">
              <a onClick={() => this.onExcluiDataClick(registro)}>
                {dataMoment.format('DD/MM/YYYY HH:mm')}
              </a>
            </Tooltip>
          </span>
        )
      } else {
        return (
          <span style={{ fontSize: 11 }}>
            {dataMoment.format('DD/MM/YYYY HH:mm')}
          </span>
        )
      }
    } else {
      <span></span>
    }
  }

  onExcluiDataClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir a data de Sincronização?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true })
        axios.put(`/vendas/excluiDataSinc/${registro.ven_idf}`)
          .then(response => {
            registro.ven_dt_enviado = '';
            this.setState({
              listaRegistros: this.state.listaRegistros.concat([]),
              qtdePedNSinc: parseInt(this.state.qtdePedNSinc) + 1,
              carregando: false
            })
          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false
            })
          })
      }
    })
  };

  onAbrirMapaClick = registro => {
    // console.log('onAbrirMapaClick: ', registro);
    if ((registro.ven_latitude) && (registro.ven_latitude)) {
      window.open("http://maps.google.com/maps?q=" + registro.ven_latitude + "," + registro.ven_longitude, '_blank')
      // window.open("http://maps.google.com/maps?q=" + registro.ven_latitude + "," + registro.ven_longitude, "minhaJanela", "height=400,width=400");
    }
  };


  onAbrirPDFClick = registro => {
    // console.log('onAbrirPDFClick: ', registro);

    this.setState({ carregando: true });
    axios.get(`/vendas/show/${registro.ven_idf}`)
      .then(response => {
        const { data } = response;

        // console.log('onAbrirPDFClick show: ', this.state.codEmpresa);
        // console.log('onAbrirPDFClick show: ', data);

        const registro = {
          ven_idf: data.dados.ven_idf,
          ven_empresa: this.state.codEmpresa,
          ven_dt_venda: data.dados.ven_dt_venda,
          ven_tipo_venda: data.dados.ven_tipo_venda,
          ven_tipo_frete: data.dados.ven_tipo_frete,
          ven_numero: data.dados.ven_numero,
          pes_nome: data.dados.pes_nome,
          ven_vlr_itens: data.dados.ven_vlr_itens,
          ven_vlr_desc: data.dados.ven_vlr_desc,
          ven_vlr_acres: data.dados.ven_vlr_acres,
          ven_vlr_frete: data.dados.ven_vlr_frete,
          ven_vlr_total: data.dados.ven_vlr_total,
          ven_pessoa: data.dados.ven_pessoa,
          ven_obs: data.dados.ven_obs,
          ven_dados_cliente: data.dados.ven_dados_cliente,
          ven_cond_pagto: data.dados.ven_cond_pagto,
          ven_usuario: data.dados.ven_usuario,
          // statusEntrega: data.dados.statusEntrega,
          gravaPDF: 1,
          retornaPDF: 0,
          listaProdutos: data.listaProdutos,
          listaEntregas: data.listaEntregas,
          listaGrades: data.listaGrades,
          listaParcelas: data.listaParcelas,
        };

        // console.log('onAbrirPDFClick registro: ', registro);
        // return;

        axios.post('/vendas/montaPDF', registro)
          .then(response => {
            const { data } = response;

            // console.log('onAbrirPDFClick: ', data);
            // console.log('onAbrirPDFClick: ', data.nomeArq);

            // const file_url1 = 'https://api.p7vendas.plenasistemas.inf.br/image/emp' + registro.ven_empresa + '/pdf/' + data.nomeArq;
            // console.log('onAbrirPDFClick: ', file_url1);

            const file_url = 'https://api.p7vendas.plenasistemas.inf.br/image/emp' + registro.ven_empresa + '/pdf/' + data.nomeArq;

            // const file_url = 'https://api.p7vendas.plenasistemas.inf.br/image/emp' + registro.ven_empresa + '/pdf/P' + String(registro.ven_idf).padStart(9, "0") + '.pdf';
            // const file_url = 'https://api.p7vendas.plenasistemas.inf.br/image/emp20/pdf/P' + String(registro.ven_idf).padStart(9, "0") + '.pdf';

            // console.log('onAbrirPDFClick: ', file_url);

            // window.open("https://api.p7vendas.plenasistemas.inf.br/image/emp7/pdf/P000034042.pdf", '_blank')
            // window.open("https://api.p7vendas.plenasistemas.inf.br/image/emp7/pdf/P" + registro.ven_idf + ".pdf", '_blank')
            window.open(file_url, '_blank')

          }).catch(ex => {
            Modal.warning({ title: 'Aviso!', content: 'Não foi possível localizar o Pedido', });
            this.setState({ carregando: false });
            console.warn(ex);
          });

        this.setState({
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };








  buscaStatus = (value) => {
    this.setState({ statusSelect: [] })
    axios.get('/statusVenda/lista', {
    }).then(response => {
      const { data } = response;
      const statusSelect = data.map(regList => {
        return {
          key: regList.sv_idf,
          label: regList.sv_descricao,
          color: regList.sv_cor,
        }
      });
      this.setState({
        statusSelect,
      })
    }).catch(error => {
      console.error(error.response);
    })
  }

  renderStatus = (sit, registro) => {
    const ven_situacao = {
      key: sit,
      label: registro.sv_descricao,
      color: registro.sv_cor
    }
    return (
      <Col xs={24} style={{ marginTop: -5, marginBottom: -30 }}>
        <InputForm
          type="select"
          id="ven_situacao"
          ref="ven_situacao"
          value={ven_situacao}
          placeholder="Status da Venda"
          onChange={situacao => this.onVerificaStatus(registro, situacao)}
          data={this.state.statusSelect}
          validator={value => Boolean(value)}
          disabled={registro.sv_descricao === 'ORÇAMENTO' ? true : false}

          style={{ width: 160, padding: 5, backgroundColor: registro.sv_cor ? registro.sv_cor : "#FFFFFF" }}
        // style={{ width: 150, color: registro.sv_cor, backgroundColor: registro.sv_cor, dropdownStyle: registro.sv_cor, itemColor: registro.sv_cor }}
        // dropdownStyle={{ backgroundColor: registro.sv_cor}}
        // itemColor={registro.sv_cor}
        // color={registro.sv_cor}

        />
      </Col>
    );
  };

  onVerificaStatus = (registro, event) => {
    // console.log('onVerificaStatus: ', event)
    if ((event.target.value.label === 'REVISAR') || (event.target.value.label === 'BLOQUEADA')) {
      this.onAbrirJustifClick(registro, event);
    } else {
      this.onChangeStatus(registro, event, '')
    }
  }

  onChangeStatus = (registro, event, justificativa) => {
    justificativa = justificativa ? justificativa : 'X';

    // console.log('onChangeStatus: ', registro)
    // console.log('onChangeStatus: ', event)
    // console.log('onChangeStatus: ', justificativa)

    this.setState({ carregando: true })
    axios.
      put(`/vendas/mudaSituacao/${registro.ven_idf}/${event.target.value.key}/${justificativa}`)
      .then(response => {
        registro.ven_situacao = event.target.value.key;
        registro.vj_data = moment().format('DD/MM/YYYY');
        registro.vj_justf_bloq = event.target.value.key;
        this.setState({
          listaRegistros: this.state.listaRegistros.concat([]),
          justificativa: '',
          registro: '',
          eventStatus: '',
          carregando: false
        }, () => {
          if (justificativa) {
            this.getListaRegistros();
          }
        })
      }).catch(error => {
        console.error(error.response);
        this.setState({ carregando: false })
      })
  };

  onAbrirJustifClick = (registro, eventStatus) => {
    this.setState({
      formJustfVisivel: true,
      registro,
      eventStatus,
      justificativa: '',
    })
  };

  onJustifClick = (registro) => {
    this.setState({
      formJustfVisivel: false,
      justificativa: registro.justificativa,
    }, this.onChangeStatus(this.state.registro, this.state.eventStatus, registro.justificativa))
  };

  onCancelarJustifClick = () => {
    this.setState({
      formJustfVisivel: false,
      justificativa: '',
      registro: '',
      eventStatus: '',
    })
  };







  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {/* <Tooltip title="Localização">
          <Button type="ghost" size="small" onClick={() => this.onAbrirMapaClick(registro)} icon="global" disabled={(registro.ven_latitude) && (registro.ven_latitude) ? false : true} />
        </Tooltip> */}

        {getTemPermissao('PedidosPage', 'editar') ? (
          <Tooltip title={registro.ven_dt_enviado ? "Visualizar" : "Editar"}>
            <Button className="botoesModalFormEditar" size="small" onClick={() => this.onEditarClick(registro, false)} icon={registro.ven_dt_enviado ? "eye" : "edit"} />
          </Tooltip>
        ) : (
          <Tooltip title="Visualizar">
            <Button className="botoesModalFormEditar" size="small" onClick={() => this.onEditarClick(registro, false)} icon="eye" />
          </Tooltip>
        )}
        {getTemPermissao('PedidosPage', 'excluir') ? (
          <Tooltip title="Excluir">
            <Button className="botoesModalFormExcluir" size="small" disabled={registro.ven_dt_enviado ? true : false} onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        ) : (
          <Tooltip title="Excluir">
            <Button className="botoesModalFormExcluir" size="small" disabled={true} onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        )}

        <Tooltip title="Imprimir Pedido">
          <Button className="botoesModalFormVisualizar" size="small" onClick={() => this.onAbrirPDFClick(registro)} icon="printer" />
        </Tooltip>

      </ButtonGroup>
    );
  };

  renderValor = (ven_vlr_total, registro) => {
    return (
      <span style={{ fontSize: 11 }}> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
    );
  };

  renderTipo = (ven_tipo_venda, registro) => {
    return (
      <div>
        {ven_tipo_venda === "O" ? (
          <Icon type="clock-circle" style={{ marginRight: 5, color: "#fdd835" }} />
        ) : ven_tipo_venda === "B" ? (
          <Icon type="pause-circle" style={{ marginRight: 5, color: "#0808EB" }} />
        ) : (
          registro.ven_dt_enviado ? (
            <Icon type="check-circle" style={{ marginRight: 5, color: "#10734a" }} />
          ) : (
            <Icon type="close-circle" style={{ marginRight: 5, color: "#b71c1c" }} />
          )
        )}
        <span style={{ fontSize: 10 }}>{ven_tipo_venda === 'P' ? 'PEDIDO' : ven_tipo_venda === 'B' ? 'BONIFICAÇÃO' : 'ORÇAMENTO'}</span>
      </div>
    );
  };

  renderCliente = (usu_nome) => {
    return (
      <span style={{ fontSize: 11 }}>{usu_nome}</span>
    );
  };

  renderUsuario = (usu_nome) => {
    return (
      <span style={{ fontSize: 11 }}>{usu_nome.substring(0, 10)}</span>
    );
  };



  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaMes: this.state.filtros.buscaMes,
        buscaAno: this.state.filtros.buscaAno,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaMunicipio: this.state.filtros.buscaMunicipio,
        buscaAgruparCidades: this.state.filtros.buscaAgruparCidades,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaTipo: this.state.filtros.buscaTipo,
        buscaControle: this.state.filtros.buscaControle,
        buscaStatusPedido: this.state.filtros.buscaStatusPedido,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };







  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado, filtros, justificativa,
      total, pagina, limite, formFiltroVisivel, formJustfVisivel, modalListaVisible, telaModal } = this.state;

    // console.log('PedidosPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <h2 className="tituloPage">Controle de Pedidos</h2>
        <hr />
        <br />

        <div className="pageFiltro" style={{ height: 70 }}>
          <Row>
            <Col xs={8} style={{ marginTop: -5 }}>
              {(!this.state.tipoUsuario) || (getTemPermissao('PedidosPage', 'novo')) ? (
                <Tooltip title="Novo Pedido Avulso">
                  <Button
                    onClick={this.onAdicionarClick}
                    className="pageFiltro-adicionar"
                  >
                    Adicionar
                  </Button>
                </Tooltip>
              ) : null}

              {(!this.state.tipoUsuario) || ((getTemPermissao('PedidosPage', 'novo')) && (getTemPermissao('OrdemProducaoPage', 'novo')) && (getTemPermissao('AnaliseProducaoPage', 'novo'))) ? (
                <Tooltip title="Novo Pedido das Ordens de Produção">
                  <Button
                    onClick={this.onNovoOrdemProducao}
                    className="pageFiltro-adicionar"
                  >
                    Produção
                  </Button>
                </Tooltip>
              ) : null}

              <Button
                onClick={this.onAbrirFiltroClick}
                className="pageFiltro-filtrar"
                style={{ marginRight: 15 }}
              >
                Filtrar
              </Button>

              <FiltrosForm
                visivel={formFiltroVisivel}
                onFiltrarClick={this.onFiltrarClick}
                onCancelarFiltroClick={this.onCancelarFiltroClick}
                filtros={filtros}
              />

              <JustificativaForm
                visivel={formJustfVisivel}
                onJustifClick={this.onJustifClick}
                onCancelarJustifClick={this.onCancelarJustifClick}
                justificativa={justificativa}
              />

              <ModalPadraoForm
                visivel={modalListaVisible}
                onNovaVendaProducaoClick={this.onNovaVendaProducaoClick}
                telaModal={telaModal}
                onFecharClick={this.onFecharModalLista}
              />

              <PedidosPrintModal
                filtros={filtros}
                vlrTotalPed={this.state.vlrTotalPed}
                qtdePed={this.state.qtdePed}
                vlrTotalOrc={this.state.vlrTotalOrc}
                qtdeOrc={this.state.qtdeOrc}
                qtdePedNSinc={this.state.qtdePedNSinc}
              />

              <PedidoForm
                visivel={formVisivel}
                onSalvarClick={this.onSalvarClick}
                onCancelarClick={this.onCancelarClick}
                carregando={salvando}
                registroSelecionado={registroSelecionado}
              />
            </Col>


            <Col xs={24} sm={16} style={{ marginTop: -15 }}>
              <Col xs={24} sm={4} style={{ margin: 5, padding: 3, textAlign: "center", background: Colors.primaryLight, color: "white", borderRadius: 3 }} >
                <Row><span style={{ fontWeight: "bold" }}>Total Pedidos</span></Row>
                <Row><span>R$ {this.renderValor(this.state.vlrTotalPed)}</span></Row>
              </Col>
              <Col xs={24} sm={4} style={{ margin: 5, padding: 3, textAlign: "center", background: Colors.primaryLight, color: "white", borderRadius: 3 }} >
                <Row><span style={{ fontWeight: "bold" }}>Qtde Pedidos</span></Row>
                <Row><span>{this.state.qtdePed}</span></Row>
              </Col>
              <Col xs={24} sm={4} style={{ margin: 5, padding: 3, textAlign: "center", background: Colors.primaryLight, color: "white", borderRadius: 3 }} >
                <Row><span style={{ fontWeight: "bold" }}>Total Orçam.</span></Row>
                <Row><span>R$ {this.renderValor(this.state.vlrTotalOrc)}</span></Row>
              </Col>
              <Col xs={24} sm={4} style={{ margin: 5, padding: 3, textAlign: "center", background: Colors.primaryLight, color: "white", borderRadius: 3 }} >
                <Row><span style={{ fontWeight: "bold" }}>Qtde Orçam.</span></Row>
                <Row><span>{this.state.qtdeOrc}</span></Row>
              </Col>
              <Col xs={24} sm={4} style={{ margin: 5, padding: 3, textAlign: "center", background: Colors.primaryLight, color: "white", borderRadius: 3 }} >
                <Row><span style={{ fontWeight: "bold" }}>Não Sincron</span></Row>
                <Row><span>{this.state.qtdePedNSinc}</span></Row>
              </Col>
            </Col>

          </Row>
        </div>



        <div style={{ marginTop: -30 }}>
          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            // scroll={{ x: 600 }}
            rowKey={(registro => registro.ven_idf)}
          >
            <Column
              key="ven_numero"
              dataIndex="ven_numero"
              title={this.renderTitulo("Núm")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="ven_dt_venda"
              dataIndex="ven_dt_venda"
              title={this.renderTitulo("Emissão")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={"13%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="ven_dt_recebido"
              dataIndex="ven_dt_recebido"
              title={this.renderTitulo("Recebido")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderDataRecebido}
              width={"15%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="ven_dt_enviado"
              dataIndex="ven_dt_enviado"
              title={this.renderTitulo("Sincronizado")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderDataEnviado}
              width={"13%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="pes_nome"
              dataIndex="pes_nome"
              title={this.renderTitulo("Cliente")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderCliente}
              width={"8%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="ven_vlr_total"
              dataIndex="ven_vlr_total"
              title={this.renderTitulo("Valor Total")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderValor}
              width={"10%"}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="usu_nome"
              dataIndex="usu_nome"
              title={this.renderTitulo("Vendedor")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"8%"}
              align="center"
              className="listaCadastro"
              render={this.renderUsuario}
            />
            <Column
              key="ven_tipo_venda"
              dataIndex="ven_tipo_venda"
              title={this.renderTitulo("Tipo")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderTipo}
              width={"10%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="ven_situacao"
              dataIndex="ven_situacao"
              title={this.renderTitulo("Status")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderStatus}
              width={'5%'}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="acoes"
              title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>Ações</div>}
              render={this.renderAcoes}
              width={"20%"}
              align="center"
              className="listaCadastro"
            />
          </Table>
        </div>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/PedidosPage.js